export enum OrganizationalDocumentType {
  FOLDER = 1,
  FILE = 2
}